import { type MutationResult, type QueryResult } from "@apollo/client";
import { type Exact } from "@/gql/generated/graphql.gen";

// biome-ignore lint/suspicious/noExplicitAny :[AUTOMATICALLY-INSERTED] Unexpected any. Specify a different type.
// biome-ignore lint/style/useConsistentArrayType :[AUTOMATICALLY-INSERTED] Use shorthand T[] syntax instead of Array<T> syntax.
export const isQueryCompleted = (resultQueries: Array<QueryResult<any, Exact<any>>>): boolean =>
  resultQueries.every((resultQuery) => resultQuery.called && !resultQuery.loading && resultQuery.data !== undefined);

// biome-ignore lint/suspicious/noExplicitAny :[AUTOMATICALLY-INSERTED] Unexpected any. Specify a different type.
// biome-ignore lint/style/useConsistentArrayType :[AUTOMATICALLY-INSERTED] Use shorthand T[] syntax instead of Array<T> syntax.
export const isMutationCompleted = (resultMutations: Array<MutationResult<any>>): boolean =>
  resultMutations.every(
    (resultMutation) => resultMutation.called && !resultMutation.loading && resultMutation.data !== undefined,
  );

// biome-ignore lint/suspicious/noExplicitAny :[AUTOMATICALLY-INSERTED] Unexpected any. Specify a different type.
// biome-ignore lint/style/useConsistentArrayType :[AUTOMATICALLY-INSERTED] Use shorthand T[] syntax instead of Array<T> syntax.
export const isLoading = (resultQueries: Array<QueryResult<any, Exact<any>>>): boolean =>
  resultQueries.some((resultQuery) => resultQuery.loading);
